export default __webpack_public_path__ + "static/media/salad.7384510c.png";